import { Pipe, PipeTransform } from '@angular/core';
import { ChipColorName } from '../../shared/mine-chip/mine-chip.enum';
import { MineChip } from '../../shared/mine-chip/mine-chip.interface';

@Pipe({
    standalone: true,
    name: 'customEntityChipBackgroundColor'
})
export class CustomEntityChipBackgroundColorPipe implements PipeTransform {

    readonly colorOpacitySuffix = '40';

    transform(color: string): string {
        if (color) {
            return color.startsWith('var(--') ? color : 
                color.endsWith(this.colorOpacitySuffix) ? color : (color + this.colorOpacitySuffix);
        }
        return MineChip.get(ChipColorName.Grey)?.backgroundColor ?? 'var(--mine-grey-light-2)';
    }
}
